import localforage from 'localforage'
import chat from './chat'
import coinAidQuestion from './coinAidQuestion'
import coinAidComment from './coinAidComment'
import commentFacebook from './commentFacebook'
import { isMagicbuyProject } from '@g/utils/projectUtils'

const state = {
  qaList: [],
  vaorderCommentList: [],
}

const getters = {
}

const mutations = {
  setQaList (state, data) {
    localforage.setItem('comment-qaList', data)
    state.qaList = data
  },
  setVaorderCommentList (state, data) {
    state.vaorderCommentList = data
  },
}

const actions = {
  index ({ state, commit, rootState }, params = {}) {
    if (isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    return rootState.axios.get('/comment/v1frontend/comment/index', { params })
  },
  getQalistForCache () {
    return localforage.getItem('comment-qaList')
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/comment/view', {
      params,
      noShowError: true
    })
  },
  createReply ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/comment/create-reply', params)
  },
  banReply ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/comment/ban-reply', params)
  },
  createWorkOrder ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    return rootState.axios.post('/comment/v1frontend/comment/create-work-order', params)
  },
  createWorkOrderAnon ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/comment/create-work-order-anon', params)
  },
  updateLike ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/comment/update-like', params)
  },
  calcWorkOrderRemainTimes ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/comment/calc-work-order-remain-times', { params })
  },
  createWishwallAppend ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/comment/create-wishwall-append', params)
  },
  searchVaorder ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/comment/search-vaorder', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    chat,
    coinAidQuestion,
    coinAidComment,
    commentFacebook,
  }
}
